// extracted by mini-css-extract-plugin
export default {"Gallery":"s_Gallery__TvLqc","img":"s_img__UCOY+"};